'use client';

import React from 'react';
import { IconTopRated } from '@repo/svgs';
import { Button } from '@/components/ui/Button';
import { useRouter } from 'next/navigation';

export function TopRatedModal() {
  const router = useRouter();

  const handleViewAllTopRated = () => {
    router.push('/nyc/top-rated-buildings');
  };

  return (
    <div className="flex flex-col gap-4">
      {/* Header Section */}
      <div className="flex flex-col gap-4 px-2">
        <IconTopRated className="w-8 h-8 text-icon-top-rated" />
        <p className="text-body-2 text-primary">
          This building is highly reviewed and rated 4+ stars by past and current renters.
        </p>
      </div>

      {/* Info Container */}
      <div className="px-2">
        <div className="bg-secondary rounded-2xl p-4">
          <p className="text-body-2 text-secondary">
            At Openigloo, we analyzed NYC open data and crowdsourced tenant reviews to identify the
            city's top-rated buildings.
          </p>
        </div>
      </div>

      {/* Action Button */}
      <div className="px-2">
        <Button variant="secondary" fullWidth onClick={handleViewAllTopRated}>
          View all top rated buildings
        </Button>
      </div>
    </div>
  );
}
